import React from 'react';
import { featureFields } from '../helpers/constants';

/**
 * Displays feature pills/tags for a bar (read-only)
 */
export function FeaturePills({ bar }) {
  const activeFeatures = featureFields.filter(f => bar[f.key]);

  if (activeFeatures.length === 0) {
    return null;
  }

  return (
    <div className="feature-pills">
      {activeFeatures.map(f => (
        <span key={f.key} className="feature-pill">
          {f.emoji} {f.label}
        </span>
      ))}
    </div>
  );
}

/**
 * Displays feature checkboxes/toggles for a form (editable)
 */
export function FeatureToggles({ values, onChange }) {
  return (
    <div className="feature-toggles">
      {featureFields.map(f => (
        <label key={f.key} className="feature-toggle">
          <input
            type="checkbox"
            checked={values[f.key] || false}
            onChange={(e) => onChange(f.key, e.target.checked)}
          />
          <span className="feature-toggle-label">
            {f.emoji} {f.label}
          </span>
        </label>
      ))}
    </div>
  );
}
